import React from 'react';
import { shallow, ShallowWrapper } from 'enzyme';
import LjDatePicker from './LjDatePicker';

const createProps = () => ({});

let props;
let wrapped: ShallowWrapper;

describe('Your description here', () => {
  beforeEach(() => {
    props = createProps();
    wrapped = shallow(<LjDatePicker {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
